module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.document) ? _c('div', {
    staticClass: "view-wrapper impressum"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.document.title))]), _vm._v(" "), _c('div', [_c('c-flex-content', {
    attrs: {
      "content": _vm.document.flex_content
    }
  })], 1)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b1e243c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Impressum.vue
// module id = 261
// module chunks = 0